import "./App.scss";
import { Suspense, lazy, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "shared/Layout";
import Aggregation from "features/Procurement/Aggregation";
import Trading from "features/Procurement/Trading";
import AddNewAgraniSathi from "features/SaathiManagement/AddNewSaathi/AddNewAgraniSathi";
import Commission from "features/SaathiManagement/Commision/Commission";
import NotFound from "global/NotFound";
import UpdaspLayout from "shared/UpdaspLayout";
import { BuyerNotification } from "features/Procurement/common/BuyerNotification";
import AgraniLandingPage from "components/agrani-website/AgraniLandingPage";
import ContactUs from "components/agrani-website/ContactUs";
import CrmAnalyticsDashboard from "features/dashboard/CrmModules/InsuranceAnalyticsDashboard";
import HclDashboard from "components/HclDashboard/HclDashboard";
import AddEmployee from "features/userManagement/AddEmployee";
import HclDashAdmin from "components/HclDashboard/HclDashAdmin";
import NewDetailViewFramer from "features/onboarding/users/farmer/NewDetailViewFramer";
import ProjectLayout from "features/dashboard/OrganizationDashboard/ProjectLayout";
import ProjectTabsComponent from "features/dashboard/Project/ProjectTabComponent";
import { AggregationParent } from "components/Aggregation/AggregationParent";
import ProjectFpoDetails from "features/dashboard/Project/ProjectFpoDetails";
// import SaathiList from 'features/SaathiManagement/SaathiList';
import { useAuth } from "react-oidc-context";
import PrivacyPolicy from "components/agrani-website/PrivacyPolicy";
import TermsAndConditions from "components/agrani-website/TermsAndConditions";
import MisDashboard from "components/analytics/BankingAnalytics/MisDashboard";
import DigitalAgricultureInsights from "features/dashboard/RiskManagement/DigitalAgricultureInsights";
import BankingMisAnalytics from "features/banking/BankingMisAnalytics";
import CrmInsurance from "features/dashboard/CrmModules/CrmInsurance";
import InsuranceParent from "features/dashboard/CrmModules/InsuranceParent";
import AllProjectDashboard from "features/dashboard/AllProjectDashboard/AllProjectDashboard";
import OliveProjectDashboard from "features/dashboard/Project/OliveProjectDashboard";

const RequireAuth = lazy(() => import("features/auth/RequireAuth"));
const Spinner = lazy(() => import("shared/Spinner"));
const Dashboard = lazy(() => import("features/dashboard/Dashboard"));
const CommonDashFC = lazy(() => import("features/dashboard/CommonDashFC"));
const FpoDashAddEmployee = lazy(() =>
  import("features/dashboard/FpoDashAddEmployee")
);
const OnboardingRoutes = lazy(() =>
  import("features/onboarding/common/OnboardingRoutes")
);
const OnboardingLeadsRoutes = lazy(() =>
  import("features/onboarding/common/OnboardingLeadsRoutes")
);
const BankingRoutes = lazy(() =>
  import("features/banking/common/BankingRoutes")
);
const Profile = lazy(() => import("features/Profile/Profile"));
const Insurance = lazy(() => import("features/Insurance/Insurance"));
const CrmDashboard = lazy(() => import("features/dashboard/CrmDashboard"));
const MasterDataRoutes = lazy(() =>
  import("features/masterdata/common/MasterDataRoutes")
);
const FarmerPricingList = lazy(() =>
  import("features/onboarding/users/farmer/FarmerPricingList")
);
const UserManagement = lazy(() =>
  import("features/userManagement/UserManagement")
);
const ViewEmployeeDetails = lazy(() =>
  import("features/userManagement/ViewEmployeeDetails")
);
const EmployeeAttendance = lazy(() =>
  import("features/userManagement/EmployeeAttendance")
);
const ProfileDashboard = lazy(() =>
  import("features/dashboard/OrganizationDashboard/ProfileDashboard")
);
const EmployeesDashboard = lazy(() =>
  import("features/dashboard/EmployeesDashboard/EmployeesDashboard")
);
const EmployeesList = lazy(() =>
  import("features/userManagement/EmployeesList")
);
const EmandiRoutes = lazy(() => import("features/E-Mandi/common/EmandiRoutes"));
const RiskManagementTabView = lazy(() =>
  import("features/dashboard/RiskManagement/RiskManagementTabView")
);
const RiskManagementSurveyDetails = lazy(() =>
  import("features/dashboard/RiskManagement/RiskManagementSurveyDetails")
);
const CrmTabView = lazy(() =>
  import("features/dashboard/CrmModules/CrmTabView")
);
// const Pmfme                 =lazy(()=>import("features/banking/Pmfme/Pmfme"))
const SaathiRoutes = lazy(() =>
  import("features/SaathiManagement/common/SaathiRoutes")
);
const SaathiViewDetails = lazy(() =>
  import("features/SaathiManagement/SaathiViewDetails")
);
const UserAttendanceReport = lazy(() =>
  import("features/userManagement/UserAttendanceReport")
);
const UserManagementAttendenceTracking = lazy(() =>
  import("features/userManagement/UserManagementAttendenceTracking")
);
const UserManagementReportsTab = lazy(() =>
  import("features/userManagement/UserManagementReportsTab")
);

// const Analytics      =lazy(()=>import("components/analytics/Analytics"))
const AnalyticsDashboard = lazy(() =>
  import("components/analytics/AnalyticsDashboard")
);
// const CrmInsurance      =lazy(()=>import("features/dashboard/CrmModules/CrmInsurance"))
const ApplicationDetailSection = lazy(() =>
  import("features/dashboard/ApplicationDetailSection")
);
const DeleteApplication = lazy(() =>
  import("features/dashboard/DeleteApplication")
);
const BuyAndSell = lazy(() => import("features/Procurement/common/BuyAndSell"));
const CropAnalyticsiframe = lazy(() =>
  import("components/CropAnalyticsIframe/CropAnalyticsiframe")
);
const ProjectLulc = lazy(() => import("SeperateDashboard/ProjectLulc"));
const FeedbackForm = lazy(() => import("components/Feedback/FeedbackForm"));
const ApprovedApplication = lazy(() =>
  import("features/dashboard/BankerLogin/ApprovedApplication")
);
const ApplicationAction = lazy(() =>
  import("features/dashboard/BankerLogin/ApplicationAction")
);
const SampleDashboard = lazy(() =>
  import("components/analytics/SampleDashboard")
);
const ManufactureContainer = lazy(() =>
  import("features/onboarding/Output/Manufacturer/ManufactureContainer")
);
const ManufacturerSummary = lazy(() =>
  import("features/onboarding/Output/Manufacturer/ManufacturerSummary")
);
// const TraderSummary      =lazy(()=>import("features/onboarding/Output/Manufacturer/TraderSummary"))
const AdminApproval = lazy(() =>
  import("features/Procurement/common/AdminApproval")
);
const ProcurementDashboard = lazy(() =>
  import("features/Procurement/common/ProcurementDashboard")
);
const YieldDashboard = lazy(() => import("SeperateDashboard/YieldDashboard"));
// const DashboardLayoutcheck      =lazy(()=>import("SeperateDashboard/DashboardLayoutcheck"))
const UpDashboard = lazy(() => import("SeperateDashboard/DashboardLayout"));
const ManufacturerLeadsDetails = lazy(() =>
  import("features/onboarding/Output/Manufacturer/ManufacturerLeadDetails")
);
const ProfileProc = lazy(() =>
  import("features/Procurement/common/ProfileProc")
);
const CustomTabs = lazy(() => import("components/CustomTabs"));
const OnBoardingForm = lazy(() =>
  import("features/Procurement/OnBoardingForm")
);
const LoginOnboardingForm = lazy(() =>
  import("components/analytics/LoginOnboardingForm")
);
const RetailersDashboard = lazy(() =>
  import("features/dashboard/RetailersDashboard")
);
const ProcurementAllOngoingTrades = lazy(() =>
  import("features/MobileProcurement/ProcurementAllOngoingTrades")
);
const ProcSellerOngoingDetails = lazy(() =>
  import("features/MobileProcurement/ProcSellerOngoingDetail")
);
const ProcBuyerInitiatedAllTrades = lazy(() =>
  import("features/MobileProcurement/ProcBuyerInitiatedAllTrades")
);
const ManageStocksAll = lazy(() =>
  import("features/MobileProcurement/ManageStocksAll")
);
const BuyerOngoingTradesAll = lazy(() =>
  import(
    "features/masterdata/common/MobileProcurementBuyer/BuyerOngoingTradesAll"
  )
);
const BuyerOngoingDetails = lazy(() =>
  import(
    "features/masterdata/common/MobileProcurementBuyer/BuyerOngoingDetails"
  )
);
const InitiatedByFarmersAll = lazy(() =>
  import(
    "features/masterdata/common/MobileProcurementBuyer/InitiatedByFarmersAll"
  )
);
const EmandiPriceTrends = lazy(() =>
  import("features/E-Mandi/EmandiPriceTrends")
);
const FarmerDetails = lazy(() =>
  import("features/onboarding/users/farmer/FarmerDetails")
);
const GovernDash = lazy(() => import("components/Government/GovernDash"));
const ParentProfileDashboard = lazy(() =>
  import("features/dashboard/OrganizationDashboard/ParentProfileDashboard")
);
const FPODetails = lazy(() =>
  import("features/onboarding/organizations/FarmersGroup/FPO/FPODetails")
);
const BankingParentLead = lazy(() =>
  import("features/banking/BankingParentLead")
);
const BankingApplicationList = lazy(() =>
  import("features/banking/BankingApplicationList")
);
// const StateHeadDashboard = lazy(() =>
//   import("features/dashboard/StateHeadDashboard")
// );
const App = () => {
  const auth = useAuth();

  useEffect(() => {
    function syncLogout(event) {
      if (event.key === "logout") {
        // console.log("Logout done");
        auth.signoutRedirect();
      }
    }
    window.addEventListener("storage", syncLogout);
    return () => {
      window.removeEventListener("storage", syncLogout);
    };
  }, [auth]);
  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route path="/" index element={<AgraniLandingPage />} />
        <Route path="/contact" index element={<ContactUs />} />
        <Route path="*" index element={<NotFound />} />
        {/* <Route path="/503" index element={<MaintenancePage />} /> */}
        <Route path="/onboard" element={<LoginOnboardingForm />}></Route>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

        <Route element={<RequireAuth />}>
          <Route
            path="/mis-dashboard"
            element={
              <div className="min-vh-100 bg-custom-color">
                <MisDashboard />
              </div>
            }
          />
          <Route
            path="/digital-agriculture"
            element={
              <div className="min-vh-100 bg-custom-color">
                <DigitalAgricultureInsights />
              </div>
            }
          />
          <Route
            path="/hcl-dashboard"
            element={
              <div className="min-vh-100 bg-custom-color">
                <HclDashboard />
              </div>
            }
          />
          <Route
            path="/projects-dashboard"
            element={
              <div className="min-vh-100 bg-custom-color">
                <AllProjectDashboard />
              </div>
            }
          />
          <Route
           path="/olive-vc-dashboard"
            element={<Navigate to="/olive-vc-dashboard/3e129491-515d-4fcb-9f36-4a42dfc7053d" replace />}
            />
           <Route
            path="/olive-vc-dashboard/:id"
            element={
              <div className="min-vh-100 bg-custom-color">
                <OliveProjectDashboard />
              </div>
            }
          />
          <Route
            path="/farmerDetail/onboarding/:id"
            element={
              <div className="min-vh-100 bg-custom-color">
                <FarmerDetails />
              </div>
            }
          />
          <Route
            path="/farmerDetails/onboarding/:id"
            element={
              <div className="min-vh-100 bg-custom-color">
                <NewDetailViewFramer />
              </div>
            }
          />
          <Route
            path="/detailView/employee/:id"
            element={
              <div className="min-vh-100 bg-custom-color">
                <AddEmployee />
              </div>
            }
          />
          <Route
            path="/project-sigma"
            element={
              <div className="min-vh-100 bg-custom-color">
                <GovernDash />
              </div>
            }
          />
          <Route
            path="/hcl-dash"
            element={
              <div className="min-vh-100 bg-custom-color">
                <HclDashAdmin />
              </div>
            }
          />
          <Route path="/project" element={<ProjectLayout />}>
            <Route index element={<ParentProfileDashboard />} />
            <Route path="dashboard" element={<ProfileDashboard />} />
            <Route
              path="dashboard/farmers-group/FPO/:id"
              element={<ProjectFpoDetails />}
            />

            <Route path="dashboard/:id" element={<ProfileDashboard />} />
          </Route>

          <Route path="/" element={<Layout />}>
            {" "}
            <Route exact path="/dashboard" element={<Dashboard />} />
            <Route exact path="/CrmDashboard" element={<CrmDashboard />} />
            <Route exact path="/org-dashboard" element={<ProfileDashboard />} />
            <Route exact path="/leads" element={<BankingParentLead />} />
            <Route exact path="/application" element={<BankingParentLead />} />
            {/* <Route exact path="/portal" element={<StateHeadDashboard />} /> */}
            {/* <Route exact path="/internal-dashboard" element={<CommonDashFC />} /> */}
            <Route exact path="/FpoDashAddEmployee/:id">
              <Route index element={<FpoDashAddEmployee />}></Route>
            </Route>
            <Route
              exact
              path="/onboarding/leads/*"
              element={<OnboardingLeadsRoutes />}
            />
            <Route exact path="/onboarding/*" element={<OnboardingRoutes />} />
            <Route exact path="/pricing" element={<FarmerPricingList />} />
            {/* <Route exact path="/banking/*" element={<BankingRoutes />} /> */}
            <Route exact path="/banking/*" element={<BankingRoutes />} />
            <Route exact path="/user-profile" element={<Profile />}></Route>
            <Route
              exact
              path="/employees-dashboard"
              element={<EmployeesDashboard />}
            ></Route>
            {/* <Route exact path="/insurance" element={<Insurance />}></Route> */}
            <Route
              exact
              path="/insurance"
              element={<InsuranceParent />}
            ></Route>
            <Route
              exact
              path="/masterdata/*"
              element={<MasterDataRoutes />}
            ></Route>
            <Route path="/user-management">
              <Route index element={<UserManagement />} />
              <Route path=":id" element={<ViewEmployeeDetails />} />
              <Route path="saathi/:id" element={<SaathiViewDetails />} />
            </Route>
            <Route
              path="/user-management/attendance"
              element={<EmployeeAttendance />}
            />
            <Route
              path="/user-management/reports"
              element={<UserManagementReportsTab />}
            />
            <Route
              path="/user-management/employee/attendance"
              element={<UserManagementAttendenceTracking />}
            />
            <Route exact path="employees" element={<EmployeesList />}></Route>
            <Route
              exact
              path="employees/:id"
              element={<EmployeesList />}
            ></Route>
            <Route path="/e-mandi/*" element={<EmandiRoutes />}></Route>
            <Route path="/priceTrends" element={<EmandiPriceTrends />}></Route>
            <Route
              path="/user-management/tracking/:id"
              element={<UserAttendanceReport />}
            />
            <Route path="/risk-management/*">
              <Route index element={<RiskManagementTabView />} />
              <Route
                path="surveydetails"
                element={<RiskManagementSurveyDetails />}
              />
            </Route>
            <Route path="/crm" element={<CrmTabView />}></Route>
            <Route
              path="/crm/application/:id"
              element={<ApplicationDetailSection />}
            ></Route>
            <Route
              path="/saathi-management/*"
              element={<SaathiRoutes />}
            ></Route>
            <Route path="/aggregation" element={<AggregationParent />}></Route>
            <Route path="/trading" element={<Trading />}></Route>
            <Route
              path="/banking/analytics/*"
              // element={<AnalyticsDashboard />}
              element={<BankingMisAnalytics />}
            ></Route>
            <Route path="/delete/*" element={<DeleteApplication />}></Route>
            <Route path="/BuyAndSell" element={<BuyAndSell />}></Route>
            <Route
              path="/crop-analytics"
              element={<CropAnalyticsiframe />}
            ></Route>
            <Route path="/ProjectDashboard" element={<ProjectLulc />}></Route>
            <Route path="/feedback" element={<FeedbackForm />}></Route>
            <Route path="/bankingLos" element={<ApprovedApplication />}></Route>
            <Route
              path="/bankingLos/:id"
              element={<ApplicationAction />}
            ></Route>
            <Route path="/trades" element={<SampleDashboard />}></Route>
            <Route path="/traders" element={<ManufactureContainer />} />
            {/* <Route  path="/outputs/Manufacturers/:id" element={<ManufacturerSummary />}></Route> */}
            <Route
              path="/outputs/:organization_type/:id"
              element={<ManufacturerSummary />}
            ></Route>
            <Route
              path="/onboarding/outputs/:organization_type/leads/:id"
              element={<ManufacturerLeadsDetails />}
            ></Route>
            <Route path="/approval-dashboard" element={<AdminApproval />} />
            <Route path="/YieldDashboard" element={<YieldDashboard />} />
            <Route
              path="/ProcurementDashboard"
              element={<ProcurementDashboard />}
            />
            <Route
              path="/ProcurementDashboard/ongoingTrades"
              element={<ProcurementAllOngoingTrades />}
            />
            <Route
              path="/ProcurementDashboard/ongoingTradess"
              element={<ProcBuyerInitiatedAllTrades />}
            />
            <Route
              path="/ProcurementDashboard/ongoingTrades/details"
              element={<ProcSellerOngoingDetails />}
            />
            <Route
              path="/ProcurementDashboard/manageStock"
              element={<ManageStocksAll />}
            />
            <Route
              path="/ProcurementDashboard/buyer/ongoingTrades"
              element={<BuyerOngoingTradesAll />}
            />
            <Route
              path="/ProcurementDashboard/buyer/ongoingTrades/details"
              element={<BuyerOngoingDetails />}
            />
            <Route
              path="/ProcurementDashboard/buyer/FarmerTrades"
              element={<InitiatedByFarmersAll />}
            />
            <Route path="/agrani-saathi" element={<AddNewAgraniSathi />} />
            <Route path="/banking/commission" element={<Commission />} />
            <Route path="/masterdata/commission" element={<Commission />} />
            {/* <Route exact path="/DashboardLayoutcheck" element={<DashboardLayoutcheck />}></Route> */}
            <Route
              exact
              path="/completeProfile/:id"
              element={<ProfileProc />}
            ></Route>
            <Route path="/custom/*" element={<CustomTabs />}></Route>
            <Route path="/retailers/*" element={<RetailersDashboard />}></Route>
            <Route
              path="/notifications/*"
              element={<BuyerNotification />}
            ></Route>
            <Route path="/custom/*" element={<CustomTabs />}></Route>
            <Route path="/retailers/*" element={<RetailersDashboard />}></Route>
            <Route
              path="/insurance/analytics"
              element={<CrmAnalyticsDashboard />}
            />
            <Route
              path="/onboarding-projects"
              element={<ProjectTabsComponent />}
            />
          </Route>
          {/* <Route path="/updasp" element={<UpdaspLayout />}> */}
          {/* <Route path='/updasp' element={<div><iframe style={{width: "100%", height: "100vh"}} src="https://updasp.agrani.io" title="Agrani | Updasp" /></div>} /> */}
          {/* </Route> */}
        </Route>
      </Routes>
    </Suspense>
  );
};

export default App;
